// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"1696cae1","703":"0ca291a2"}[chunkId] + ".chunk.js";
};